export default "__VITE_ASSET__1e1d0e43__"